import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface SalesDocumentTemplateNotFoundModalProps {
  title: string
  salesDocumentTemplateId: string
  onClose: () => void
}

export const SalesDocumentTemplateNotFoundModal = ({
  title,
  salesDocumentTemplateId,
  onClose,
}: SalesDocumentTemplateNotFoundModalProps) => {
  return (
    <Modal
      illustration="template"
      title={title}
      description={i18n.t('finance.sales_document_templates.modal.template_not_found')}
      onClose={onClose}
      footer={
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.close')}
        </Button>
      }
    >
      <Box gap="s16">
        <Text.Normal>
          {i18n.t('finance.sales_document_templates.modal.template_not_found_message', {
            id: salesDocumentTemplateId,
          })}
        </Text.Normal>
      </Box>
    </Modal>
  )
}
